import { useMemo } from "react";

import { isOverduePendingActivities } from "org/dashboardPendingActivities/tableUtils";
import { PendingActivityTableRow } from "org/dashboardPendingActivities/types";

interface PendingActivitiesCount {
    count: number;
    isOverdue: boolean;
}

export function usePendingActivitiesCount(
    rows: PendingActivityTableRow[]
): PendingActivitiesCount {
    const isOverdueArray = useMemo(
        () => isOverduePendingActivities(rows),
        [rows]
    );

    return {
        count: rows.length,
        isOverdue: isOverdueArray.some(Boolean),
    };
}
